// Components==============
import GoogleMapReact from 'google-map-react';
import React, { useState, useContext } from 'react';
import { SchoolsContext } from 'screens/Schools/Schools';
import Location from '../Location/Location';
import './Maps.module.scss';
// =========================
export default function Maps({ schools }) {
    const [storedMap, setStoredMap] = useState(null);
    const [zoomNumber, setZoomNumber] = useState(10);
    const { setSelected } = useContext(SchoolsContext);

    const defaultProps = {
        center: {
            lat: 51.73,
            lng: 5.75,
        },
        zoom: zoomNumber,
        maxZoom: 13,
    };

    const mapOptions = {
        maxZoom: 13,
        minZoom: 9,
    };

    const initialLat = 51.73;
    const initialLng = 5.75;

    const apiIsLoaded = (map) => {
        if (map) {
            setStoredMap(map);
            // const latLng = maps.LatLng(lat, lng); // Makes a latlng
            // map.panTo({ initialLat, initialLng });
        }
    };

    function calculateOffset() {
        switch (zoomNumber) {
            case 10:
                return 0.1;
            case 11:
                return 0.08;
            case 12:
                return 0.04;
            case 13:
                return 0.02;
            default:
                return 0.1;
        }
    }

    function onPress(lat, lng) {
        storedMap.panTo({ lat: lat + calculateOffset(), lng });
    }

    function zoomChanged(zoom) {
        setZoomNumber(zoom);
    }

    return (
        <div styleName="wrapper">
            <GoogleMapReact
                onClick={() => setSelected(null)}
                onGoogleApiLoaded={({ map, maps }) =>
                    apiIsLoaded(map, maps, initialLat, initialLng)
                }
                bootstrapURLKeys={{
                    key: process.env.MIX_GOOGLE_MAPS_API_KEY,
                }}
                defaultCenter={defaultProps.center}
                defaultZoom={defaultProps.zoom}
                onZoomAnimationEnd={zoomChanged}
                maxZoom={13}
                options={mapOptions}
            >
                {schools.map((item) => (
                    <Location
                        onPress={onPress}
                        item={item}
                        lat={item?.contact?.lat}
                        lng={item?.contact?.long}
                        index={item?.index}
                        key={`${item.index}`}
                        map
                    />
                ))}
            </GoogleMapReact>
        </div>
    );
}
